import type { GameScene } from '../core/Scene';

export abstract class Entity {
  readonly id: string = crypto.randomUUID();

  abstract update(deltaSeconds: number): void;
  abstract addToScene(scene: GameScene): void;
  abstract removeFromScene(scene: GameScene): void;

  dispose(): void {}
}
